import React, { useState } from "react";
import styled from "styled-components";
import ContainerButton from "./ContainerButton";
import { Loader, HoverCard, Text } from "@mantine/core";
import { IconInfoCircle, IconQuestionMark } from "@tabler/icons-react";
import GoogleDrivePickerAndUploader from "../components/Lib/FilesPickerAndUploader";
import useStartupStore from "../stores/startupStore";
import Mixpanel from "../components/Lib/mixpanel";
import { useTranslation } from "react-i18next";
import { t } from "i18next";
// Styled components
const AttachedDocuments = styled.div``;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 10px;
`;

const ActionButton = styled.button`
  background-color: var(--color-container-card-default);
  border: none;
  border-radius: 4px;
  padding: 7px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

const DocumentUpload = () => {
  const {t}=useTranslation();
  const [loading, setLoading] = useState(false);
  const { submitPendingChanges, isMember, isOwner, pendingChanges, selectedProgram, content } = useStartupStore(
    (state) => ({
      submitPendingChanges: state.submitPendingChanges,
      isMember: state.isMember,
      isOwner: state.isOwner,
      pendingChanges: state.pendingChanges,
      selectedProgram: state.selectedProgram,
      content: state.content,
    })
  );

  return (
    <AttachedDocuments>
      {(isOwner || isMember) && (
        <ButtonContainer>
          {loading ? (
            <Loader
              className="mx-auto"
              color="indigo"
              size="lg"
              variant="bars"
            />
          ) : (
            <div style={{ display: "flex", alignItems: "center", gap: 8, width: "100%" }}>
              {(() => {
                const cid = selectedProgram.cid;
                const sid = selectedProgram.sid;
                const hasPending = !!(pendingChanges?.[cid]?.[sid]);
                const sub = content?.[cid]?.[sid];
                const hasContentDiff = !!(sub && sub.response !== sub.originalResponse);
                const canCommit = hasPending || hasContentDiff;
                return (
              <ContainerButton
                action={async () => {
                  setLoading(true);
                  Mixpanel.content("Pending Changes", "Saved & Completed", {});
                  const result = await submitPendingChanges();
                  setLoading(false);
                }}
                buttonText={"Commit changes"}
                fullWidth
                disabled={!canCommit}
              />
                );
              })()}
              <HoverCard width={320} position="bottom" withArrow shadow="md">
                <HoverCard.Target>
                  <ActionButton aria-label="About commit">
                    <IconQuestionMark size={16} />
                  </ActionButton>
                </HoverCard.Target>
                <HoverCard.Dropdown>
                  <Text size="sm" fw={600} mb={4}>What does Commit changes do?</Text>
                  <Text size="sm" mb={6}>- Creates a versioned snapshot of your current content</Text>
                  <Text size="sm" mb={6}>- Notifies your team about the finalized update (activity logged)</Text>
                  <Text size="sm">Note: Autosave updates the content incrementally and is visible to your team, but it does not create version history or team notifications.</Text>
                </HoverCard.Dropdown>
              </HoverCard>
            </div>
          )}
        </ButtonContainer>
      )}
    </AttachedDocuments>
  );
};

export default DocumentUpload;
